import React, { Fragment, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import emailjs from 'emailjs-com';
import { trackFormSubmission, trackEvent } from '../../analytics';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Bg from '../../images/bg/page_bg01.jpg';
import CtaSection from '../../components/CtaSection/CtaSection';
import icon from '../../images/icon/magic.svg';
import gImg1 from '../../images/gallery/cp-img01.jpg';
import gImg2 from '../../images/gallery/cp-img02.jpg';
import gImg3 from '../../images/gallery/cp-img03.jpg';
import gImg4 from '../../images/gallery/cp-img04.jpg';
import gImg5 from '../../images/gallery/cp-img05.jpg';
import gImg6 from '../../images/gallery/cp-img06.jpg';
import { jobListings } from '../../api/joblistings';

const CareerSingle = () => {
    const { jobId } = useParams();
    const [job, setJob] = useState(null);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        resume: null,
        coverLetter: null,
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const foundJob = jobListings.find((job) => job.id === parseInt(jobId));
        setJob(foundJob);
    }, [jobId]);

    if (!job) {
        return <div>Loading...</div>;
    }

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (files) {
            const file = files[0];
            const validExtensions = ['pdf', 'png', 'jpg', 'jpeg', 'docx'];
            const fileExtension = file.name.split('.').pop().toLowerCase();
            const maxSize = 3 * 1024 * 1024; // 3 MB

            if (!validExtensions.includes(fileExtension)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: 'Invalid file type. Only pdf, png, jpg, jpeg, and docx are allowed.',
                }));
                return;
            }

            if (file.size > maxSize) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: 'File size exceeds the limit of 3 MB.',
                }));
                return;
            }

            setFormData({
                ...formData,
                [name]: file,
            });
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: '',
            }));
            
            // Track file upload for analytics
            trackEvent('Career Application', 'File Upload', `${name}_${fileExtension}`, Math.round(file.size / 1024)); // Size in KB
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: '',
            }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const newErrors = {};

        if (!validateName(formData.name)) {
            newErrors.name = 'Name should only contain alphabets and spaces, and be less than 60 characters.';
        }

        if (!validateEmail(formData.email)) {
            newErrors.email = 'Please enter a valid email address.';
        }

        if (formData.phone && !validatePhone(formData.phone)) {
            newErrors.phone = 'Phone number should be 10 digits.';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Prepare email data
        const emailData = {
            job_id: jobId,
            job_title: job.title,
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            resume: formData.resume,
            coverLetter: formData.coverLetter,
        };

        // Track form submission attempt
        trackEvent('Career Application', 'Form Submit Attempt', job.title);

        // Send email using EmailJS
        emailjs.send('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', emailData, 'YOUR_USER_ID')
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                // Track successful form submission
                trackFormSubmission(`Career_Application_${job.title}`, true);
                trackEvent('Career Application', 'Form Submit Success', job.title);
            }, (error) => {
                console.log('FAILED...', error);
                // Track failed form submission
                trackFormSubmission(`Career_Application_${job.title}`, false);
                trackEvent('Career Application', 'Form Submit Failed', job.title);
            });

        // Handle form submission logic here
        console.log(formData);
    };

    const validateName = (name) => {
        const nameRegex = /^[A-Za-z\s]{1,60}$/;
        return nameRegex.test(name);
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validatePhone = (phone) => {
        const phoneRegex = /^[0-9]{10}$/;
        return phoneRegex.test(phone);
    };

    return (
        <Fragment>
            <div className='body_wrap sco_agency'>
                <Header />
                <section className="page-title cp-page-title pt-200 pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
                    <div className="container">
                        <div className="page-title-wrap">
                            <div className="row mt-none-30 align-items-center">
                                <div className="col-lg-8 mt-30">
                                    <div className="page-title-box">
                                        <span className="sub-title"><img src={icon} alt="" />Careers</span>
                                        <h2 className="title">Be a part of shaping the <br /> future & career opportunities <br /> at Bogin Tech today.</h2>
                                    </div>
                                </div>
                                <div className="col-lg-4 mt-30">
                                    <div className="cp-img-slide">
                                        <div className="cp-img-inner ul_li">
                                            <div className="cp-item marquee-first">
                                                <div className="xb-img"><img src={gImg1} alt="" /></div>
                                                <div className="xb-img"><img src={gImg2} alt="" /></div>
                                                <div className="xb-img"><img src={gImg3} alt="" /></div>
                                                <div className="xb-img"><img src={gImg1} alt="" /></div>
                                                <div className="xb-img"><img src={gImg2} alt="" /></div>
                                                <div className="xb-img"><img src={gImg3} alt="" /></div>
                                            </div>
                                            <div className="cp-item marquee-2">
                                                <div className="xb-img"><img src={gImg4} alt="" /></div>
                                                <div className="xb-img"><img src={gImg5} alt="" /></div>
                                                <div className="xb-img"><img src={gImg6} alt="" /></div>
                                                <div className="xb-img"><img src={gImg4} alt="" /></div>
                                                <div className="xb-img"><img src={gImg5} alt="" /></div>
                                                <div className="xb-img"><img src={gImg6} alt="" /></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="cp-det-bg">
                    <section className="career-details">
                        <div className="container">
                            <div className="cp-details-wrap">
                                <div className="cp-manager_info">
                                    <h2 className="xb-item--title">{job.title}</h2>
                                    <ul className="xb-details-content list-unstyled">
                                        <li><span>Department :</span> {job.categories.join(", ")}</li>
                                        <li><span>Location :</span> {job.location}</li>
                                        <li><span>Type :</span> {job.type}</li>
                                        <li><span>Pay :</span> {job.pay}</li>
                                    </ul>
                                    <p className="xb-item--content">
                                        {job.description}
                                    </p>
                                </div>
                                <div className="xb-details-item">
                                    <h3 className="xb-item--title">Key Responsibilities</h3>
                                    <ul className="xb-details-content">
                                        {job.roles.map((role, index) => (
                                            <li key={index}>{role}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="cp-contact-wrap pt-130 pb-130">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="cs-contact-wrap cs-contact-form cd-contact-form">
                                        <h2 className="xb-title">Apply for this job</h2>
                                        <p className="xb-content">Bogin Tech doesn’t accept unsolicited resumes from recruiters or employment agencies.</p>
                                        <form onSubmit={handleSubmit} className="contact-form">
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="input-field">
                                                        <label htmlFor="name">Name*</label>
                                                        <div className="input-box">
                                                            <input 
                                                                type="text" 
                                                                name="name" 
                                                                id="name" 
                                                                value={formData.name} 
                                                                onChange={handleChange} 
                                                                required 
                                                                maxLength="60" 
                                                                pattern="[A-Za-z\s]{1,60}" 
                                                                title="Name should only contain alphabets and spaces, and be less than 60 characters."
                                                            />
                                                            {errors.name && <p style={{ color: 'orange', fontStyle: 'italic' }}>{errors.name}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="input-field">
                                                        <label htmlFor="email">Email*</label>
                                                        <div className="input-box">
                                                            <input 
                                                                type="email" 
                                                                name="email" 
                                                                id="email" 
                                                                value={formData.email} 
                                                                onChange={handleChange} 
                                                                required 
                                                                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" 
                                                                title="Please enter a valid email address."
                                                            />
                                                            {errors.email && <p style={{ color: 'orange', fontStyle: 'italic' }}>{errors.email}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="input-field">
                                                        <label htmlFor="phone">Phone (optional)</label>
                                                        <div className="input-box">
                                                            <input 
                                                                type="tel" 
                                                                name="phone" 
                                                                id="phone" 
                                                                value={formData.phone} 
                                                                onChange={handleChange} 
                                                                pattern="[0-9]{10}" 
                                                                title="Phone number should be 10 digits."
                                                            />
                                                            {errors.phone && <p style={{ color: 'orange', fontStyle: 'italic' }}>{errors.phone}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="input-field">
                                                        <label htmlFor="resume">Resume*</label>
                                                        <div className="input-box">
                                                            <input 
                                                                type="file" 
                                                                name="resume" 
                                                                id="resume" 
                                                                onChange={handleChange} 
                                                                required 
                                                            />
                                                            {errors.resume && <p style={{ color: 'orange', fontStyle: 'italic' }}>{errors.resume}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="input-field">
                                                        <label htmlFor="coverLetter">Cover Letter (optional)</label>
                                                        <div className="input-box">
                                                            <input 
                                                                type="file" 
                                                                name="coverLetter" 
                                                                id="coverLetter" 
                                                                onChange={handleChange} 
                                                            />
                                                            {errors.coverLetter && <p style={{ color: 'orange', fontStyle: 'italic' }}>{errors.coverLetter}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="cp-contact-bottom ul_li_between mt-20">
                                                <div className="xb-item--left mt-20">
                                                    <p className="xb-item--content"><span>Accepted file types :</span> pdf, png, jpg, jpeg, docx. Max. file size: 3 MB.</p>
                                                </div>
                                                <div className="cp-det-btn mt-20">
                                                    <button className="cp-btn">Submit now <i className="fal fa-arrow-right"></i></button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CtaSection />
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default CareerSingle;